import { render, staticRenderFns } from "./periodDetail.vue?vue&type=template&id=d4bb47f4&"
import script from "./periodDetail.vue?vue&type=script&lang=ts&"
export * from "./periodDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports